import React from 'react'

import { Feature } from 'core'
import { ProductIds } from 'core/application/commons/config'

import { useFeatureFlag } from 'common/hooks'

import useCurrentProduct from '../../../common/hooks/useCurrentProduct'
import GroupHraDesignBenefitSummary from './groupHra/designBenefitSummary'
import IchraDesignBenefitSummary from './ichra/designBenefitSummary'
import IchraDesignBenefitSummaryV2 from './ichra/designBenefitSummaryV2'
import PerksDesignBenefitSummary from './perks/designBenefitSummary'
import QsehraDesignBenefitSummary from './qsehra/designBenefitSummary'

import '../BenefitDetailsStyles.less'

const productBenefitDesignSummary = new Map<number, any>()
productBenefitDesignSummary.set(ProductIds.GroupHraId, <GroupHraDesignBenefitSummary />)
productBenefitDesignSummary.set(ProductIds.Perks, <PerksDesignBenefitSummary />)
productBenefitDesignSummary.set(ProductIds.QsehraId, <QsehraDesignBenefitSummary />)

const DesignBenefitSummary: React.FC = () => {
  const product = useCurrentProduct()
  const showNewBenefitDetailsDesignForIchra = useFeatureFlag(Feature.ShowNewDesignForBenefitDetails)
  productBenefitDesignSummary.set(
    ProductIds.IchraId,
    showNewBenefitDetailsDesignForIchra ? <IchraDesignBenefitSummaryV2 /> : <IchraDesignBenefitSummary />,
  )
  return <div data-testid={'benefit-details-page'}>{productBenefitDesignSummary.get(product.productId)}</div>
}

export default DesignBenefitSummary
